export default __webpack_public_path__ + "static/media/1773.862c7e37.png";